export type FuseLogoProps = React.HTMLProps<HTMLImageElement> & {
  white?: boolean;
};

export const FuseLogo: React.FC<FuseLogoProps> = ({ white, ...props }) =>
  white ? (
    <img alt="Fuse Logo" src={new URL('/public/images/brand/logo-white.png', import.meta.url).toString()} {...props} />
  ) : (
    <img alt="Fuse Logo" src={new URL('/public/images/brand/fuse-logo-2.png', import.meta.url).toString()} {...props} />
  );
